module.exports = __webpack_public_path__ + "img/headerlogo.5a8d73a6.png";